export const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  export const week = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // export const weekEnum = Object.freeze({
  //   Sunday: 0,
  //   Monday: 1,
  //   Tuesday: 2,
  //   Wednesday: 3,
  //   Thursday: 4,
  //   Friday: 5,
  //   Saturday: 6,
  // });
  
  export const periodEnum = Object.freeze({
    Last: 0,
    First: 1,
    Second: 2,
    Third: 3,
    Fourth: 4,
  });

  export const period = ["", "First", "Second", "Third", "Fourth", "Last"];